/**
 * section-best-sellers.js
 * Place in: assets/section-best-sellers.js
 */

(function () {
  'use strict';

  function initSlider(section) {
    const sectionId = section.id.replace('best-sellers-', '');
    const track     = section.querySelector('#bsTrack-' + sectionId);
    const prevBtn   = section.querySelector('#bsPrev-' + sectionId);
    const nextBtn   = section.querySelector('#bsNext-' + sectionId);
    const dotsWrap  = section.querySelector('#bsDots-' + sectionId);

    if (!track) return;

    // Guard against double-init
    if (track.dataset.sliderReady === 'true') return;
    track.dataset.sliderReady = 'true';

    const autoplay = section.dataset.autoplay !== 'false';
    const speed    = parseInt(section.dataset.speed, 10) || 3000;

    // ── Collect original cards ──────────────────────────────────
    const originals = Array.from(track.querySelectorAll('.product-card'));
    const total     = originals.length;
    if (total === 0) return;

    // ── Clone for infinite loop ─────────────────────────────────
    // Prepend clones of originals (reversed), append clones of originals
    originals.slice().reverse().forEach(function (card) {
      track.insertBefore(card.cloneNode(true), track.firstChild);
    });
    originals.forEach(function (card) {
      track.appendChild(card.cloneNode(true));
    });

    // current points to the first *real* card (after the prepended clones)
    var current         = total;
    var isTransitioning = false;
    var autoTimer       = null;

    // ── Card width ─────────────────────────────────────────────
    // Measured as the distance between two consecutive cards' left
    // edges, so it naturally includes the card's horizontal margins
    // (getBoundingClientRect().width alone does not).
    function getCardWidth() {
      var cards = track.querySelectorAll('.product-card');
      if (cards.length === 0) return 0;
      if (cards.length > 1) {
        var step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
        if (step > 0) return step;
      }
      var rect       = cards[0].getBoundingClientRect();
      var style      = window.getComputedStyle(cards[0]);
      var marginLeft  = parseFloat(style.marginLeft) || 0;
      var marginRight = parseFloat(style.marginRight) || 0;
      return rect.width + marginLeft + marginRight;
    }

    // ── Position ───────────────────────────────────────────────
    function setPosition(index, animate) {
      var w = getCardWidth();
      if (w === 0) return; // layout not ready yet, skip
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      track.style.transform  = 'translateX(-' + (index * w) + 'px)';
    }

    // ── Dots ───────────────────────────────────────────────────
    function updateDots() {
      var dotIndex = (current - total + total * 100) % total; // always positive
      dotsWrap.querySelectorAll('.slider-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === dotIndex);
        d.setAttribute('aria-current', i === dotIndex ? 'true' : 'false');
      });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.className = 'slider-dot' + (idx === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          btn.setAttribute('aria-current', idx === 0 ? 'true' : 'false');
          btn.addEventListener('click', function () {
            if (isTransitioning) return;
            current = total + idx;
            setPosition(current, true);
            updateDots();
            resetAuto();
          });
          dotsWrap.appendChild(btn);
        })(i);
      }
    }

    // ── Navigation ─────────────────────────────────────────────
    function goNext() {
      if (isTransitioning) return;
      isTransitioning = true;
      current++;
      setPosition(current, true);
      updateDots();
    }

    function goPrev() {
      if (isTransitioning) return;
      isTransitioning = true;
      current--;
      setPosition(current, true);
      updateDots();
    }

    // Silent boundary jump after transition
    track.addEventListener('transitionend', function () {
      isTransitioning  = false;
      var allCount     = track.querySelectorAll('.product-card').length;
      var clonesBefore = total;
      var clonesAfter  = total;

      if (current >= allCount - clonesAfter) {
        current = clonesBefore + (current - (allCount - clonesAfter));
        setPosition(current, false);
      } else if (current < clonesBefore) {
        current = allCount - clonesAfter - (clonesBefore - current);
        setPosition(current, false);
      }
    });

    // ── Autoplay ───────────────────────────────────────────────
    function startAuto() {
      if (!autoplay) return;
      autoTimer = setInterval(goNext, speed);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    prevBtn.addEventListener('click', function () { goPrev(); resetAuto(); });
    nextBtn.addEventListener('click', function () { goNext(); resetAuto(); });

    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);

    // Touch / swipe
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? goNext() : goPrev();
        resetAuto();
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      setPosition(current, false);
    });

    // ── Boot: wait for layout paint before measuring ────────────
    // requestAnimationFrame alone isn't enough inside Shopify themes;
    // a 0ms setTimeout after rAF guarantees the browser has painted.
    requestAnimationFrame(function () {
      setTimeout(function () {
        buildDots();
        setPosition(current, false);
        updateDots();
        startAuto();
      }, 0);
    });
  }

  // ── Find and init all instances ────────────────────────────────
  function bootAll() {
    document.querySelectorAll('.best-sellers[id^="best-sellers-"]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.best-sellers[id^="best-sellers-"]');
    if (section) {
      // Reset ready flag so it can re-init cleanly
      var track = section.querySelector('[id^="bsTrack-"]');
      if (track) track.dataset.sliderReady = 'false';
      initSlider(section);
    }
  });

})();
